module.exports = __webpack_public_path__ + "img/crv1.ab8e2789.jpg";